import React from 'react';
import classNames from 'classnames';
var CarouselItem = React.forwardRef(function (props, ref) {
    var _a = props.prefixCls, prefixCls = _a === void 0 ? 'ty-carousel-item' : _a, className = props.className, style = props.style, children = props.children;
    var cls = classNames(prefixCls, className);
    return (React.createElement("li", { ref: ref, className: cls, style: style }, children));
});
CarouselItem.displayName = 'CarouselItem';
export default CarouselItem;
//# sourceMappingURL=carousel-item.js.map